import { useState } from "react";
import { FilterMatchMode, FilterOperator } from "primereact/api";

export function useContractsFilters() {
  const [collabsGlobalFilterValue, setCollabsGlobalFilterValue] = useState("");
  const [missionsGlobalFilterValue, setMissionsGlobalFilterValue] = useState("");
  const [missionsSuivisGlobalFilterValue, setMissionsSuivisGlobalFilterValue] = useState("");

  const [collabsFilters, setCollabsFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    matricule: { value: null, matchMode: FilterMatchMode.CONTAINS },
    current_poste: { value: null, matchMode: FilterMatchMode.CONTAINS },
    nature_emploi: { value: null, matchMode: FilterMatchMode.CONTAINS },
    etablissement: { value: null, matchMode: FilterMatchMode.CONTAINS },
    current_team_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
    nom: { value: null, matchMode: FilterMatchMode.CONTAINS },
    prenom: { value: null, matchMode: FilterMatchMode.CONTAINS },
    type_collab: { value: null, matchMode: FilterMatchMode.EQUALS },
    motif_sortie: { value: null, matchMode: FilterMatchMode.IN },
    statut: { value: null, matchMode: FilterMatchMode.EQUALS },
    company: { value: null, matchMode: FilterMatchMode.EQUALS },
    periodeEssai1: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
    },
    periodeEssai2: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
    },
    exitDate: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
    },
    type_contrat: { value: null, matchMode: FilterMatchMode.IN },
    new_date_fin_cp: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
    },
    date_debut_cp: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
    },
    date_fin_cp: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
    },
  });

  const [missionsFilters, setMissionsFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    nom: { value: null, matchMode: FilterMatchMode.CONTAINS },
    prenom: { value: null, matchMode: FilterMatchMode.CONTAINS },
    statut: { value: null, matchMode: FilterMatchMode.EQUALS },
    start_date: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
    },
    end_date: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
    },
  });

  const [missionsSuivisFilters, setMissionsSuivisFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    nom: { value: null, matchMode: FilterMatchMode.CONTAINS },
    prenom: { value: null, matchMode: FilterMatchMode.CONTAINS },
    type: { value: null, matchMode: FilterMatchMode.EQUALS },
    status: { value: null, matchMode: FilterMatchMode.EQUALS },
    client: { value: null, matchMode: FilterMatchMode.EQUALS },
    current_team_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
  });

  const onCollabsGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...collabsFilters };
    _filters["global"].value = value;
    setCollabsFilters(_filters);
    setCollabsGlobalFilterValue(value);
  };

  const onMissionsGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...missionsFilters };
    _filters["global"].value = value;
    setMissionsFilters(_filters);
    setMissionsGlobalFilterValue(value);
  };

  const onMissionsSuivisGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...missionsSuivisFilters };
    _filters["global"].value = value;
    setMissionsSuivisFilters(_filters);
    setMissionsSuivisGlobalFilterValue(value);
  };

  return {
    collabsFilters,
    missionsFilters,
    missionsSuivisFilters,
    collabsGlobalFilterValue,
    missionsGlobalFilterValue,
    missionsSuivisGlobalFilterValue,
    onCollabsGlobalFilterChange,
    onMissionsGlobalFilterChange,
    onMissionsSuivisGlobalFilterChange,
  };
}
